import useAsyncData from "../../../../../hooks/use-async-data";
import billingService from "../../../billings.service";
import BillingsPlanEntryRelatedCargoTaxi from "./billings-plan-entry-related-cargo-taxi";
import BillingsPlanEntryRelatedCargoTaxiParams from "./billings-plan-entry-related-cargo-taxi-params";

const useBillingsPlanEntryRelatedCargoTaxi = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<BillingsPlanEntryRelatedCargoTaxi>({
      data: [],
    });

  const load = async (
    params: BillingsPlanEntryRelatedCargoTaxiParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const cargoTaxi =
        await billingService.getPlanEntryRelatedCargoTaxiBillings(
          params,
          signal,
        );

      setData(cargoTaxi);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useBillingsPlanEntryRelatedCargoTaxi;
